import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'

import { BeneficiaryListWithFiltersAndPagination } from '@/components/beneficiary/list/BeneficiaryListWithFiltersAndPagination'
import { Description } from '@/components/beneficiary/list/Description'

export function BeneficiaryListRoute() {
  const { t } = useT({ keyPrefix: 'admin.beneficiaryList' })
  return (
    <Card className="flex flex-1 flex-col overflow-hidden overflow-y-auto">
      <CardHeader>
        <CardTitle>{t('title', { cfl: true })}</CardTitle>
        <CardDescription>
          <Description />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <BeneficiaryListWithFiltersAndPagination />
      </CardContent>
    </Card>
  )
}
